import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiFileText, FiMail, FiLock } = FiIcons;

const PrivacyTerms = () => {
  const sections = [
    {
      icon: FiLock,
      title: "Data Privacy & Collection",
      content: [
        "At Fiverring, we believe in complete transparency and privacy by design.",
        "We do NOT collect, store, or process any personal user data on our servers.",
        "This platform operates as a static directory. No account creation is required, and no tracking cookies are used by us to monitor your behavior.",
        "Any interaction you have with the third-party tools listed on this site is subject to their respective privacy policies."
      ]
    },
    {
      icon: FiFileText,
      title: "Terms of Service",
      content: [
        "Fiverring is a directory of AI tools provided 'as is' for informational purposes only.",
        "We are not responsible for the availability, content, or functionality of external sites linked from our platform.",
        "While we strive to verify all listings, use the tools at your own discretion and risk.",
        "By using this site, you agree to these terms and acknowledge that Fiverring is an independent aggregator not affiliated with the listed tools unless explicitly stated."
      ]
    },
    {
      icon: FiMail,
      title: "Contact Us",
      content: [
        "Have questions, suggestions, or want to report a listing?",
        "You can reach us directly at:",
        "Email: contact.daddacool@gmail.com",
        "We aim to respond to all inquiries within 48 hours."
      ]
    }
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-16"
      >
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 mb-6 shadow-lg shadow-purple-500/20">
          <SafeIcon icon={FiShield} className="text-3xl text-white" />
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          Privacy & Terms
        </h1>
        <p className="text-white/60 text-lg">
          Transparency is our core value.
        </p>
      </motion.div>

      <div className="space-y-8">
        {sections.map((section, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 + 0.2 }}
            className="bg-white/5 backdrop-blur-xl rounded-2xl border border-white/10 p-8 hover:border-white/20 transition-colors"
          >
            <div className="flex items-start space-x-4">
              <div className="mt-1 p-2 bg-white/10 rounded-lg">
                <SafeIcon icon={section.icon} className="text-xl text-purple-400" />
              </div>
              <div className="flex-1">
                <h2 className="text-2xl font-bold text-white mb-4">{section.title}</h2>
                <div className="space-y-3">
                  {section.content.map((text, i) => (
                    <p key={i} className={`text-white/70 leading-relaxed ${text.startsWith('Email:') ? 'font-mono bg-white/5 p-3 rounded-lg inline-block text-purple-300' : ''}`}>
                      {text}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
        className="mt-12 text-center text-white/40 text-sm"
      >
        Last updated: {new Date().toLocaleDateString()}
      </motion.div>
    </div>
  );
};

export default PrivacyTerms;